import { BsFillShieldLockFill, BsTelephoneFill } from "react-icons/bs";
import { CgSpinner } from "react-icons/cg";
import { SiZalo } from "react-icons/si";
import { useState, useEffect, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { auth } from "./firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { toast, Toaster } from "react-hot-toast";
import { useCookies } from 'react-cookie';

const OTP_LENGTH = 6;

export const OtpCodeInput = ({ value, onChange }) => {
  const inputRefs = useRef([]);
  const digits = value.padEnd(OTP_LENGTH, " ").split("");

  const fillFrom = (index, inputValue) => {
    const newDigits = value.padEnd(OTP_LENGTH, " ").split("");
    const enteredDigits = inputValue.replace(/\D/g, "");

    if (!enteredDigits) {
      newDigits[index] = " ";
      onChange(newDigits.join("").trimEnd());
      return;
    }

    enteredDigits.slice(0, OTP_LENGTH - index).split("").forEach((digit, offset) => {
      newDigits[index + offset] = digit;
    });

    onChange(newDigits.join("").replace(/\s/g, ""));
    inputRefs.current[Math.min(index + enteredDigits.length, OTP_LENGTH - 1)]?.focus();
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !digits[index] && index > 0) {
      event.preventDefault();
      const newValue = value.slice(0, index - 1) + value.slice(index);
      onChange(newValue);
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (event, index) => {
    event.preventDefault();
    fillFrom(index, event.clipboardData.getData("text"));
  };

  return (
    <div className="opt-container">
      {Array.from({ length: OTP_LENGTH }, (_, index) => (
        <input
          key={index}
          ref={(element) => { inputRefs.current[index] = element; }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete={index === 0 ? "one-time-code" : "off"}
          maxLength={OTP_LENGTH}
          value={digits[index] === " " ? "" : digits[index]}
          onChange={(event) => fillFrom(index, event.target.value)}
          onKeyDown={(event) => handleKeyDown(event, index)}
          onPaste={(event) => handlePaste(event, index)}
          onFocus={(event) => event.target.select()}
          autoFocus={index === 0}
          aria-label={`Số OTP thứ ${index + 1}`}
        />
      ))}
    </div>
  );
};

const App = () => {
  const [otp, setOtp] = useState("");
  const [ph, setPh] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [user, setUser] = useState(null);
  const [cookies, setCookie] = useCookies(['user']);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const phone = urlParams.get('phone');

    if (phone) {
      setPh("+84" + phone.replace(/^(?:\+84|0)/, ''));
    }
  
  }, []);
  function onCaptchVerify() {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            onSignup();
          },
          "expired-callback": () => {},
        },
        auth
      );
    }
  }

  function onSignup() {
    setLoading(true);
    onCaptchVerify();

    const appVerifier = window.recaptchaVerifier;

    const formatPh = "+" + ph;
    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        setLoading(false);
        setShowOTP(true);
        toast.success("Đã gửi mã xác thực!");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Nếu bạn khó khăn trong quá trình đăng nhập, hãy liên hệ admin. ("+error.message+")");

        setLoading(false);
      });
  }

  function onOTPVerify() {
    setLoading(true);
    window.confirmationResult
      .confirm(otp)
      .then(async (res) => {
        console.log(res);
        setCookie('accessToken', res.user.accessToken);
        setUser(res.user);
        setLoading(false);
        toast.success("Xác thực thành công...")
        window.location.href = '/?action=success';
        console.log("Redirected");
      })
      .catch((error) => {
        if (error && error.message && error.message.includes('invalid-verification-code')) {
          toast.error("Mã bạn nhập không đúng.");
        }else{
          toast.error("Nếu bạn khó khăn trong quá trình đăng nhập, hãy liên hệ admin. ("+error.message+")");
        }
        setLoading(false);
      });
  }

  function onContactAdmin() {
    window.location.href = 'https://zalo.me/0944889705';
  }

  return (
    <section style={{ backgroundColor: '#000000' }} className="bg-emerald-500 flex items-center justify-center h-screen">
      <div>
        <Toaster toastOptions={{ duration: 4000 }} />
        <div id="recaptcha-container"></div>
        {user ? (
          <h2 className="text-center text-white font-medium text-2xl">
            👍 Xác thực thành công!
          </h2>
        ) : (
          <div className="w-[calc(100vw-2rem)] max-w-xs flex flex-col gap-4 rounded-lg p-4">
            <h1 className="text-center leading-normal text-white font-medium text-3xl mb-6">
              Xác thực <br /> Số điện thoại
            </h1>
            {showOTP ? (
              <>
                <div className="bg-white text-emerald-500 w-fit mx-auto p-4 rounded-full">
                  <BsFillShieldLockFill size={30} />
                </div>
                <label
                  htmlFor="otp"
                  className="font-bold text-xl text-white text-center"
                >
                  Nhập Mã OTP
                </label>
                <OtpCodeInput
                  value={otp}
                  onChange={setOtp}
                />
                <button
                  onClick={onOTPVerify}
                  className="bg-emerald-600 w-full flex gap-1 items-center justify-center py-2.5 text-white rounded"
                >
                  {loading && (
                    <CgSpinner size={20} className="mt-1 animate-spin" />
                  )}
                  <span>Xác Nhận OTP</span>
                </button>
              </>
            ) : (
              <>
                <div className="bg-white text-emerald-500 w-fit mx-auto p-4 rounded-full">
                  <BsTelephoneFill size={30} />
                </div>
                <label
                  htmlFor=""
                  className="font-bold text-xl text-white text-center"
                >
                  Nhập số điện thoại của bạn
                </label>
                <PhoneInput country={"vn"} onlyCountries={['vn']} value={ph} onChange={setPh} />
                <button
                  onClick={onSignup}
                  className="bg-emerald-600 w-full flex gap-1 items-center justify-center py-2.5 text-white rounded"
                >
                  {loading && (
                    <CgSpinner size={20} className="mt-1 animate-spin" />
                  )}
                  <span>Gửi mã xác thực</span>
                </button>
              </>
            )}
            <div className="mt-2 flex flex-col gap-2 text-center">
              <p className="text-sm text-gray-300">
                Nếu bạn không đăng nhập được, vui lòng
              </p>
              <button
                type="button"
                onClick={onContactAdmin}
                className="flex w-full items-center justify-center gap-2 rounded border border-emerald-500 py-2.5 font-medium text-emerald-500 transition-colors hover:bg-emerald-500 hover:text-white"
              >
                <SiZalo size={22} />
                Liên hệ Admin
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default App;
